import dayjs from "dayjs"
import weekOfYear from "dayjs/plugin/weekOfYear"
import isoWeek from "dayjs/plugin/isoWeek"
import utc from "dayjs/plugin/utc"
import timezone from "dayjs/plugin/timezone"
import isoWeeksInYear from "dayjs/plugin/isoWeeksInYear"
import isLeapYear from "dayjs/plugin/isLeapYear"

const plugin = () => {
  // 加載插件
  dayjs.extend(weekOfYear)
  dayjs.extend(isoWeek)
  dayjs.extend(utc)
  dayjs.extend(timezone)
  dayjs.extend(isoWeeksInYear)
  dayjs.extend(isLeapYear)
}

const timeZoneGMTMap: Record<string, string> = {
  "GMT+0": "Etc/GMT",
  "GMT+5": "Etc/GMT-5",
  "GMT+5:45": "Asia/Kathmandu",
  "GMT+6": "Etc/GMT-6",
  "GMT+7": "Etc/GMT-7",
  "GMT+8": "Etc/GMT-8",
  "GMT-4": "Etc/GMT+4",
  "GMT-7": "Etc/GMT+7",
  "GMT-11": "Etc/GMT+11"
}

const setTimezone = (zone: string) => {
  if (zone === "") {
    const timeZone = dayjs.tz.guess()

    dayjs.tz.setDefault(timeZone)
  } else {
    const timeZone = timeZoneGMTMap[zone] || zone

    dayjs.tz.setDefault(timeZone)
  }
}

export { setTimezone, plugin }
export default plugin
